import { z } from 'zod';
import { accountBadgeSchema } from '../entities/AccountBadgeEntityTypes';
import { badgeSchema } from '../entities/BadgeEntityTypes';
export const badgeResponseSchema = z.object({
    id: z.string(),
    data: badgeSchema,
    columns: z.custom(),
    created: z.number().optional(),
    createdBy: z.string().optional(),
    updated: z.number().optional(),
    updatedBy: z.string().optional(),
    permissions: z.string().array().optional(),
});
export const accountBadgeResponseSchema = z.object({
    id: z.string(),
    data: accountBadgeSchema,
    columns: z.custom(),
    created: z.number().optional(),
    createdBy: z.string().optional(),
    updated: z.number().optional(),
    updatedBy: z.string().optional(),
    permissions: z.string().array().optional(),
});
